// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'satoshi', 'satoshi Fallback', system-ui, arial"},"className":"__className_72ab7a","variable":"__variable_72ab7a"};